import { Margin, Strong } from '@ovotech/element-v5';
import { StyledHeading, StyledP } from './Cancel.styled';
import React from 'react';
import { PlanDetails } from '@monovo/ev-anytime';
import { getFormattedPlanTitle, isOemPlan } from './Confirmations';

export const PaydCancelSuccess = () => {
  return (
    <>
      <StyledHeading>You’ve cancelled pay as you go</StyledHeading>
      <Margin vertical={4}>
        <StyledP>
          We've removed this plan from your OVO tariff. After your final
          charging credit is applied to your account, your charging data will no
          longer be shared with OVO, or visible in your OVO account.
        </StyledP>
      </Margin>
      <StyledP>
        Your cancellation will take effect at midnight. If you've removed{' '}
        <Strong>pay as you go</Strong> by mistake, or you've changed your mind,
        you can sign up again once the cancellation is complete.
      </StyledP>
    </>
  );
};

export const MonthlyCancelSuccess = ({
  currentPlan,
  partnership,
}: {
  currentPlan: PlanDetails;
  partnership?: string | null;
}) => {
  const currentPlanTitle = getFormattedPlanTitle(
    currentPlan,
    partnership,
    isOemPlan(currentPlan),
  );
  return (
    <>
      <StyledHeading>You’ve cancelled {currentPlanTitle}</StyledHeading>
      <Margin vertical={4}>
        <StyledP>
          We've removed the plan from your OVO tariff. After your final charging
          credit is applied to your account, your charging data will no longer
          be shared with OVO, or visible in your OVO account.
        </StyledP>
      </Margin>
      <StyledP>
        Your cancellation will take effect at the end of the month. If you've
        removed your <Strong>monthly plan</Strong> by mistake, or you've changed
        your mind, you can sign up again after the cancellation is complete.
      </StyledP>
    </>
  );
};

export const InitializedCancelSuccess = ({
  futurePlan,
  partnership,
}: {
  futurePlan: PlanDetails;
  partnership?: string | null;
}) => {
  const futurePlanTitle = getFormattedPlanTitle(
    futurePlan,
    partnership,
    isOemPlan(futurePlan),
  );
  return (
    <>
      <StyledHeading>You’ve cancelled {futurePlanTitle}</StyledHeading>
      <Margin vertical={4}>
        <StyledP>
          Your cancellation will take effect immediately. If you've removed
          Charge Anytime by mistake, or you've changed your mind, you can sign
          up again.
        </StyledP>
      </Margin>
    </>
  );
};

export const SwitchCancelSuccess = ({
  currentPlan,
  futurePlan,
  partnership,
}: {
  currentPlan: PlanDetails;
  futurePlan: PlanDetails;
  partnership?: string | null;
}) => {
  const futurePlanTitleHeader = getFormattedPlanTitle(
    futurePlan,
    partnership,
    false, // No "your" in the heading
  );
  const futurePlanTitleBody = getFormattedPlanTitle(
    futurePlan,
    partnership,
    isOemPlan(futurePlan),
  );
  const currentPlanTitleBody = getFormattedPlanTitle(
    currentPlan,
    partnership,
    isOemPlan(currentPlan),
  );

  return (
    <>
      <StyledHeading>
        You’ve cancelled your switch to {futurePlanTitleHeader}
      </StyledHeading>
      <Margin vertical={4}>
        <StyledP>
          We've removed <Strong>{futurePlanTitleBody}</Strong> from your OVO
          tariff and you will continue to be on{' '}
          <Strong>{currentPlanTitleBody}</Strong>.
        </StyledP>
      </Margin>
    </>
  );
};
